import { render, staticRenderFns } from "./reset-search.vue?vue&type=template&id=037b534e&"
import script from "./reset-search.vue?vue&type=script&lang=ts&"
export * from "./reset-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports